import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { metaConsentGranted } from "@/lib/metaPixel";
import { gaConsentGranted } from "@/lib/googleAnalytics";

const KEY = "mira-cookie-consent";

export default function CookieBanner() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    if (value === "all") { metaConsentGranted(); gaConsentGranted(); }
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[90] mx-auto max-w-2xl rounded-3xl border p-5 sm:p-6 shadow-[0_24px_48px_-24px_rgba(44,39,37,0.35)]"
          style={{ background: "var(--surface)", borderColor: "var(--line)", backdropFilter: "blur(16px)" }}
          data-testid="cookie-banner"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <p className="flex-1 text-sm leading-relaxed" style={{ color: "var(--on-surface)" }}>
              <span style={{ color: "var(--gold)" }}>✦ </span>
              {t.cookie.text}{" "}
              <Link to="/datenschutz" data-testid="cookie-privacy-link" className="gold-underline font-medium" style={{ color: "var(--camel)" }}>
                {t.cookie.more}
              </Link>
            </p>
            <div className="flex shrink-0 items-center gap-2.5">
              <button
                data-testid="cookie-decline-btn"
                onClick={() => choose("essential")}
                className="rounded-full border px-5 py-2.5 text-xs font-medium transition-colors duration-300 hover:border-[var(--camel)] hover:text-[var(--camel)]"
                style={{ borderColor: "var(--line)" }}
              >
                {t.cookie.decline}
              </button>
              <button
                data-testid="cookie-accept-btn"
                onClick={() => choose("all")}
                className="pill-btn rounded-full px-5 py-2.5 text-xs font-medium text-white"
                style={{ background: "var(--camel)" }}
              >
                {t.cookie.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
